// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthTriggerController from "./auth_trigger_controller"
application.register("auth-trigger", AuthTriggerController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CollapsibleTextController from "./collapsible_text_controller"
application.register("collapsible-text", CollapsibleTextController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EpisodeAccordionController from "./episode_accordion_controller"
application.register("episode-accordion", EpisodeAccordionController)

import EpisodeActionsController from "./episode_actions_controller"
application.register("episode-actions", EpisodeActionsController)

import EpisodeWatchButtonController from "./episode_watch_button_controller"
application.register("episode-watch-button", EpisodeWatchButtonController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import ExpandableOverviewController from "./expandable_overview_controller"
application.register("expandable-overview", ExpandableOverviewController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import JustwatchOffersController from "./justwatch_offers_controller"
application.register("justwatch-offers", JustwatchOffersController)

import MediaSearchController from "./media_search_controller"
application.register("media-search", MediaSearchController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MovieFormController from "./movie_form_controller"
application.register("movie-form", MovieFormController)

import MovieNotificationController from "./movie_notification_controller"
application.register("movie-notification", MovieNotificationController)

import MovieSelectController from "./movie_select_controller"
application.register("movie-select", MovieSelectController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProgressAccordionController from "./progress_accordion_controller"
application.register("progress-accordion", ProgressAccordionController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import RebrandBannerController from "./rebrand_banner_controller"
application.register("rebrand-banner", RebrandBannerController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SeasonTabsController from "./season_tabs_controller"
application.register("season-tabs", SeasonTabsController)

import SeasonsGridController from "./seasons_grid_controller"
application.register("seasons-grid", SeasonsGridController)

import SmartBackButtonController from "./smart_back_button_controller"
application.register("smart-back-button", SmartBackButtonController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StickyBackButtonController from "./sticky_back_button_controller"
application.register("sticky-back-button", StickyBackButtonController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TrailerController from "./trailer_controller"
application.register("trailer", TrailerController)

import TurboFormController from "./turbo_form_controller"
application.register("turbo-form", TurboFormController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import WatchlistButtonController from "./watchlist_button_controller"
application.register("watchlist-button", WatchlistButtonController)
